import { useContext } from "react";
import { TimerContext } from "../context/timer/timer-context";

export const useTimerContext = () => {
  const context = useContext(TimerContext);

  if (!context) {
    throw new Error(
      "useTimerContext must be used within a TimerContextProvider"
    );
  }
  return context;
};
